import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'
import { services } from '../../data/data'

function Services() {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className='container services__container'>
        {services.map((s, i) => (
          <Service {...s} key={i} />
        ))}
      </div>
    </section>
  )
}

const Service = ({ title, list }) => {
  return (
    <article className='service'>
      <div className='service__head'>
        <h3>{title}</h3>
      </div>
      <ul className='service__list'>
        {list.map((l, i) => (
          <li key={i}>
            <BiCheck className='service__list-icon' />
            <p>{l}</p>
          </li>
        ))}
      </ul>
    </article>
  )
}

export default Services
